import Transactions from 'components/activity/transactions/main/containers/TransactionsContainer';

export default [{ path: '', component: Transactions, pageTitle: 'Home' }];
